/* global */
(function() {
    'use strict';

    angular.module('GorillaBoy')
    .controller('gbShareModalCtrl', [
        '$q',
        '$rootScope',
        '$scope',
        '$translate',
        '$document',
        '$timeout',
        '$uibModalInstance',
        '$sce',
        '$window',
        'ClientMetricsService',
        'DocumentService',
        'MessageManager',
        'MessageProvider',
        'MetricEvents',
        'ResourceService',
        'AppConstants',
        'isFolder',
        'pendingShareType',
        'shareResourceId',
        'shareResourceName',
        'isAnonymous',
        'currentOwnerInfo',
        'currentOwnerUsername',
        'shareOnly',
        'CommentsLocked',
        'FeatureManagerService',
        'Features',
        'BrowserService',
        'SignalProvider',
        '$log',
        gbShareModalController
    ]);

    function gbShareModalController($q, $rootScope, $scope, $translate, $document, $timeout,
        $uibModalInstance, $sce, $window, ClientMetricsService, DocumentService,
        MessageManager, MessageProvider, MetricEvents, ResourceService, AppConstants,
        isFolder, pendingShareType, shareResourceId, shareResourceName, isAnonymous,
        currentOwnerInfo, currentOwnerUsername, shareOnly,
        CommentsLocked, FeatureManagerService, Features, BrowserService, SignalProvider, $log) {

        var TYPE_FOLDER = 'FOLDER',
            TYPE_DOCUMENT = 'DOCUMENT',
            SHARE_RESULT = {
                FEEDBACK_FAILURE: 'FAILED',
                SHARE_FAILURE: 'FAILURE'
            },

            // AppConstant bindings
            collaboratorTypes = AppConstants.CollaboratorTypes,
            globalRoles = AppConstants.GlobalRoles,
            language = $translate.use(),

            FIVE_PM = 17,
            VALIDATION_EXCEPTION_DEADLINE_IN_PAST = 'ValidationException: The feedback deadline can\'t be in the past',
            VALIDATION_EXCEPTION_MESSAGE_EXCEEDS_LIMIT = '1 validation error detected: Value at \'message\' failed to satisfy constraint: Member must have length less than or equal to 2048',
            SHARE_FAILURE = 'FAILURE',
            FAILED_TO_INVITE_OR_SHARE_COOWNER = 'Failed to invite new user for role COOWNER',
            FAILED_TO_INVITE_OR_SHARE_CONTRIBUTOR = 'Failed to invite new user for role CONTRIBUTOR',
            FAILED_TO_INVITE_COOWNER_TO_MINIMALUSER = 'Failed to invite new minimal user for role COOWNER',
            FAILED_TO_INVITE_CONTRIBUTOR_TO_MINIMALUSER = 'Failed to invite new minimal user for role CONTRIBUTOR',
            FAILED_TO_SHARE_TO_MINIMALUSER = 'Minimal user can only have Viewer permissions.',

            SHARE_LINK_OPTION = {
                READ: {
                    name: 'READ',
                    title: $translate.instant('MODAL.SHARE_MODAL.READ_LINK'),
                    text: 'MODAL.SHARE_MODAL.READ_TEXT'
                },
                READ_WRITE: {
                    name: 'READ_WRITE',
                    title: $translate.instant('MODAL.SHARE_MODAL.READ_WRITE_LINK'),
                    text: 'MODAL.SHARE_MODAL.READ_WRITE_TEXT'
                },
                PRIVATE: {
                    name: 'PRIVATE',
                    title: $translate.instant('MODAL.SHARE_MODAL.PRIVATE_LINK'),
                    text: 'MODAL.SHARE_MODAL.PRIVATE_TEXT'
                }
            },
            principalId = null,
            principalRole = null,
            updateLink = false,
            previousLinkOption = null,
            previousDirectSharedPrincipalsMap = {};

        activate();
        $scope.feedbackDisabled = (CommentsLocked || '').toLowerCase() === "true";
        $scope.isSharingFolder = pendingShareType === TYPE_FOLDER;
        $scope.hideFeedbackButton = $scope.feedbackDisabled || $scope.isSharingFolder;

        function activate() {
            $scope.SHARE_LINK_OPTION = SHARE_LINK_OPTION;
            $scope.GlobalRoles = globalRoles;
            $scope.maxChars = AppConstants.MAX_CHARS;
            $scope.charsRemaining = AppConstants.MAX_CHARS;
            $scope.currentOwnerUsername = currentOwnerUsername;
            $scope.currentOwnerInfo = currentOwnerInfo;
            $scope.message = '';
            $scope.deadline = null;
            $scope.deadlineTime = null;
            $scope.openMessage = false;
            $scope.openFeedback = false;
            $scope.collaborators = [];
            $scope.removedCollaborators = [];
            $scope.feedbackRequested = false;
            $scope.allFeedbackRequested = false;
            $scope.hideFeedbackButton = false;
            $scope.sharedPrincipals = null;
            $scope.numContributors = null;
            $scope.collaboratorRoleUpdated = false;
            $scope.showGroupAndNonContributorMessage = false;
            $scope.disableSaveBtn = true;
            $scope.dateOptions = {
                minDate: 0
            };
            $scope.shareLinkOption = null;

            // execute below
            updateShareLinkInput();

            if (shareOnly) {
            	hideFeedback();
            }

            // title
            $scope.title = $translate.instant('FILE_ACTIONS.SHARE_INVITE');

            // Link Part Title
            var linkPartTitleText = (shareOnly === 'FOLDER') ?
                $translate.instant('MODAL.SHARE_MODAL.LINK_PART_TITLE_FOLDER') : $translate.instant('MODAL.SHARE_MODAL.LINK_PART_TITLE_FILE');

            $scope.linkPartTitle = $sce.trustAsHtml(linkPartTitleText);

            // Invite Poeple Descr
            $scope.invitePeopleDescr = (shareOnly === 'FOLDER') ?
                $translate.instant('MODAL.SHARE_MODAL.SHARE_PART_FOLDER') : $translate.instant('MODAL.SHARE_MODAL.SHARE_PART_FILE');

            //set the region for the datepicker
            $.datepicker.setDefaults($.datepicker.regional[language]);
            getOrganizationPrincipals();
            getSharedPrincipals();

            $scope.useMeridian = function() {
                var arr = ['en', 'ko', 'zh-cn'];
                if (arr.indexOf(language) > -1) {
                    return true;
                } else {
                    return false;
                }
            };

            $scope.openMessageInput = function() {
                $scope.openMessage = true;
                updateShareButtonState();
            };

            $scope.closeMessageInput = function() {
                $scope.message = '';
                $scope.charsRemaining = AppConstants.MAX_CHARS;
                $scope.openMessage = false;
                updateShareButtonState();
            };

            $scope.addFeedback = function() {
                $scope.openFeedback = true;
                if (noContributors()) {
                    $scope.showGroupAndNonContributorMessage = true;
                } else {
                    var numCollaborators = $scope.collaborators.length,
                        collaborator;

                    // Pre-select all new shares if "Request feedback" is clicked.
                    for (var i = 0; i < numCollaborators; i++) {
                        collaborator = $scope.collaborators[i];
                        if (collaborator.roleType === globalRoles.CONTRIBUTOR && collaborator.type === collaboratorTypes.USER) {
                            collaborator.feedbackRequested = true;
                            $scope.feedbackRequested = true;
                        }
                    }

                    $scope.showGroupAndNonContributorMessage = false;
                }
            };

            function noContributors() {
                var numCollaborators = $scope.collaborators.length,
                    numSharedPrincipals = $scope.sharedPrincipals.direct.length;

                for (var i = 0; i < numCollaborators; i++) {
                    if ($scope.collaborators[i].roleType === globalRoles.CONTRIBUTOR && $scope.collaborators[i].type === collaboratorTypes.USER) {
                        return false;
                    }
                }

                for (var j = 0; j < numSharedPrincipals; j++) {
                    if ($scope.sharedPrincipals.direct[j].Role === globalRoles.CONTRIBUTOR && $scope.sharedPrincipals.direct[j].Type === collaboratorTypes.USER) {
                        return false;
                    }
                }

                return true;
            }

            $scope.closeFeedback = function() {
                $scope.openFeedback = false;
                updateShareButtonState();
            };

            $scope.openSharelinkModal = function() {
            	$uibModalInstance.close({
                	isOpenShareLinkModal: true
                });
            };

            $scope.showLinkSharing = function() {
            	return AppConstants.ORG_WIDE_SHARING_SCOPE !== 'NONE'; 
            };

            $scope.syncTime = function() {
                if ($scope.deadline) {
                    if (!$scope.deadlineTime) {
                        $scope.deadline.setHours(FIVE_PM, 0, 0);
                    } else {
                        $scope.deadline.setHours($scope.deadlineTime.getHours(), $scope.deadlineTime.getMinutes());
                    }
                }
            };

            $scope.setInitialDate = function() {
                if (!$scope.deadline) {
                    var now = new Date();
                    if (now.getHours() >= FIVE_PM) {
                        // set date to tomorrow
                        now.setDate(now.getDate() + 1);
                    }
                    $scope.deadline = now;
                    $scope.shareRequested = false;
                    $scope.syncTime();
                }
            };

            $scope.charCounter = function() {
                if ($scope.message) {
                    $scope.charsRemaining = AppConstants.MAX_CHARS - $scope.message.length;
                }
            };

            $scope.submitRequest = function(form) {
                if ($scope.disableSaveBtn) {
                    return;
                }

                var done = $q.defer(),
                    promises = [];

                if (updateLink) {
                    promises.push(updateShareLinkPermission());
                }

                //remove the permission of users
                if ($scope.removedCollaborators.length > 0) {
                    promises.push(deletePermission($scope.removedCollaborators));
                }

                // Show an error message only when the date/time form is invalid for the feedback request.
                if (form.$invalid && $scope.feedbackRequested) {
                    MessageManager.addErrorMessage(MessageProvider.documentContributePermissionFailDeadlineInvalidTime);
                    return;
                }

                // collaborators for ResourceService
                var collaborators = [],
                    feedbackRequestList = [],
                    data;

                // For newly shared users
                angular.forEach($scope.collaborators, function(value) {
                    var collaborator = null;

                    // For permissions V2 user and group typeahead, each element in $scope.collaborators is
                    // a wrapper for a user, a group, and an anonymous user.
                    if (!value.feedbackRequested) {

                    	if (FeatureManagerService.isFeatureEnabled(Features.PermissionsV2.GROUPMODAL)) {
                    	    collaborator = resourceServiceCollaborator(value);
		                } else {
	                        collaborator = {
	                            id: value.id,
	                            email: value.email,
	                            type: value.type,
	                            role: value.roleType
	                        };
	                    }

	                    collaborators.push(collaborator);
                    }
                });

                // If changed previous shared principals' role, add to list.
                angular.forEach($scope.sharedPrincipals.direct, function(principal) {
                    if (principal.type !== collaboratorTypes.ANONYMOUS && principal.Role !== globalRoles.OWNER && previousDirectSharedPrincipalsMap[principal.Id] !== principal.Role) {
                        var sharedPerson = null;
                        if (!principal.feedbackRequested) {
                            if (FeatureManagerService.isFeatureEnabled(Features.PermissionsV2.GROUPMODAL)) {
                                sharedPerson = resourceServiceExistedCollaborator(principal);
                            } else {
                                sharedPerson = {
                                    id: principal.Id,
                                    email: principal.Username,
                                    type: principal.Type,
                                    role: principal.Role
                                };
                            }

                            collaborators.push(sharedPerson);
                        }
                    }
                });

                // For feedback requests
                angular.forEach($scope.collaborators, function(user) {
                    if (user.roleType === globalRoles.CONTRIBUTOR && user.feedbackRequested) {
                        if (FeatureManagerService.isFeatureEnabled(Features.PermissionsV2.GROUPMODAL)) {
                            feedbackRequestList.push(resourceServiceCollaborator(user));
                        } else {
                            feedbackRequestList.push({
                                id: user.id,
                                email: user.email,
                                type: user.type,
                                role: user.roleType
                            });
                        }
                    }
                });

                angular.forEach($scope.sharedPrincipals.direct, function(principal) {
                    if (principal.Role === globalRoles.CONTRIBUTOR && principal.feedbackRequested) {
                        if (FeatureManagerService.isFeatureEnabled(Features.PermissionsV2.GROUPMODAL)) {
                            feedbackRequestList.push(resourceServiceExistedCollaborator(principal));
                        } else {
                            feedbackRequestList.push({
                                id: principal.Id,
                                email: principal.Username,
                                type: principal.Type,
                                role: principal.Role
                            });
                        }
                    }
                });

                if (collaborators.length === 0 && feedbackRequestList.length === 0 && !updateLink && $scope.removedCollaborators.length === 0) {
                    $uibModalInstance.dismiss();
                    return;
                }

                data = {
                    shareResourceId: shareResourceId,
                    feedbackRequested: $scope.feedbackRequested,
                    role: null,
                    collaborators: collaborators,
                    feedbackRequestList: feedbackRequestList,
                    message: $scope.message,
                    deadline: $scope.deadline
                };

                $scope.syncTime();

                if (collaborators.length !== 0 || feedbackRequestList.length !== 0) {
                    promises.push(createPermission(data));
                }

                if (promises.length === 0) {
                    if (pendingShareType === TYPE_FOLDER) {
                        ClientMetricsService.cancelLatencyEvent(MetricEvents.FOLDER_SHARE_MODAL_DWELL_TIME_WITH_CHANGES);
                        ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents.FOLDER_SHARE_MODAL_DWELL_TIME_NO_CHANGES);
                    } else if (pendingShareType === TYPE_DOCUMENT) {
                        ClientMetricsService.cancelLatencyEvent(MetricEvents.DOCUMENT_SHARE_MODAL_DWELL_TIME_WITH_CHANGES);
                        ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents.DOCUMENT_SHARE_MODAL_DWELL_TIME_NO_CHANGES);
                    }
                }

                $q.all(promises).then(function success() {
                    if (pendingShareType === TYPE_FOLDER) {
                        ClientMetricsService.cancelLatencyEvent(MetricEvents.FOLDER_SHARE_MODAL_DWELL_TIME_NO_CHANGES);
                        ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents.FOLDER_SHARE_MODAL_DWELL_TIME_WITH_CHANGES);
                    } else if (pendingShareType === TYPE_DOCUMENT) {
                        ClientMetricsService.cancelLatencyEvent(MetricEvents.DOCUMENT_SHARE_MODAL_DWELL_TIME_WITH_CHANGES);
                        ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents.DOCUMENT_SHARE_MODAL_DWELL_TIME_NO_CHANGES);
                    }

                    $uibModalInstance.close();

                    if (promises.length === 1) {
                        if (updateLink) {
                            MessageManager.addSuccessMessage(MessageProvider.linkUpdateSuccess);
                        } else if ($scope.removedCollaborators.length > 0) {
                            MessageManager.addSuccessMessage(MessageProvider.collaboratorRemoveSuccess);
                        } else {
                            if (data.feedbackRequested) {
                                MessageManager.addSuccessMessage(MessageProvider.feedbackRequestSuccess);
                            } else if (isFolder) {
                                MessageManager.addSuccessMessage(MessageProvider.folderShareSuccess);
                            } else {
                                MessageManager.addSuccessMessage(MessageProvider.documentShareSuccess);
                            }
                        }
                    } else if (promises.length > 1) {
                        MessageManager.addSuccessMessage(MessageProvider.allChangesDone);
                    }

                    done.resolve();
                }, function error(errorObj) {
                    if (errorObj) {
                        $log.log("Failed to share. ErrorObj: ");
                        // If share Status is not empty then it mean it return some details message.
                        if (errorObj.Status === SHARE_FAILURE &&
                            (errorObj.StatusMessage === FAILED_TO_INVITE_OR_SHARE_COOWNER ||
                            	errorObj.StatusMessage === FAILED_TO_INVITE_OR_SHARE_CONTRIBUTOR)) {
                                MessageManager.addErrorMessage(MessageProvider.documentContributePermissionFailOutsider);
                        } else if (errorObj.Status === SHARE_FAILURE &&
                            (errorObj.StatusMessage === FAILED_TO_INVITE_COOWNER_TO_MINIMALUSER  ||
                            	errorObj.StatusMessage === FAILED_TO_INVITE_CONTRIBUTOR_TO_MINIMALUSER ||
                                errorObj.StatusMessage === FAILED_TO_SHARE_TO_MINIMALUSER)) {
                                MessageManager.addErrorMessage(MessageProvider.documentContributePermissionFailMinimalUser);
                        } else if (errorObj.data && errorObj.data.message) {
                            if (errorObj.data.message.indexOf(VALIDATION_EXCEPTION_DEADLINE_IN_PAST) >= 0) {
                                MessageManager.addErrorMessage(MessageProvider.documentContributePermissionFailDeadlineInPast);
                            } else if (errorObj.data.message.indexOf(VALIDATION_EXCEPTION_MESSAGE_EXCEEDS_LIMIT) >= 0) {
                                MessageManager.addErrorMessage(MessageProvider.messageExceedsLimit);
                            }
                        } else {
                            if(errorObj && errorObj.Message && errorObj.Message.indexOf('NoRetryThrottlingException') >= 0) {
                                MessageManager.addErrorMessage($translate.instant('MESSAGES.INVITE_SEND_FAIL_LIMIT_REACHED'));
                            } else {
                                MessageManager.addErrorMessage(MessageProvider.defaultShareFailure);
                            }
                        }
                    } else {
                        MessageManager.addErrorMessage(MessageProvider.documentContributePermissionFailDefault);
                    }
                    done.reject();
                }).finally(function() {
                    $rootScope.$broadcast(SignalProvider.Permission.PermissionUpdated);
                });

                return done.promise;
            };

            $scope.$watch('numContributors', function() {
                if ($scope.numContributors > 0) {
                    $scope.showGroupAndNonContributorMessage = false;
                } else if ($scope.numContributors === 0) {
                    if ($scope.openFeedback) {
                        $scope.showGroupAndNonContributorMessage = true;
                    }
                }
            });

            $scope.$watch('removedCollaborators', function() {
                updateShareButtonState();
            }, true);

            $scope.$watch('collaborators', function() {
                updateShareButtonState();
            }, true);

            $scope.$watch('collaboratorRoleUpdated', function() {
                updateShareButtonState();
            }, true);

            $scope.$watch('feedbackRequested', function() {
                updateShareButtonState();
            }, true);
        }

        function updateShareButtonState() {
            //Save
            if (($scope.openMessage) ||
                ($scope.collaboratorRoleUpdated) ||
                ($scope.feedbackRequested) ||
                (previousLinkOption && $scope.shareLinkOption && previousLinkOption.name !== $scope.shareLinkOption.name) ||
                ($scope.removedCollaborators && $scope.removedCollaborators.length > 0) ||
                ($scope.collaborators && $scope.collaborators.length > 0)) {
                $scope.disableSaveBtn = false;
            } else {
                $scope.disableSaveBtn = true;
            }

        }

        //This is only used for "shareOnly" file. if it is shareOnly like a folder, then hide the feedback content.
        function hideFeedback() {
            $scope.hideFeedbackButton = true;
            $scope.openFeedback = false;
            $scope.feedbackRequested = false;
        }

        /**
         * Helpers for permissions V2 user and group typeahead.
         */
        function deletePermission(users) {
            var done = $q.defer(),
                promises = [];

            if (!users) {
                done.reject();
                return done.promise;
            }

            function updateList() {
                $rootScope.$broadcast(SignalProvider.Permission.PrincipalRemoved);
            }

            function deleteSinglePermission(person) {
                var completed = $q.defer();
                if (!person) {
                    completed.reject();
                    return completed.promise;
                }

                ResourceService.deleteResourcePermission(shareResourceId, person.Id).then(function() {
                    $scope.sharedPrincipals.direct.splice($scope.sharedPrincipals.direct.indexOf(person), 1);
                    completed.resolve();
                }, function(error) {
                    completed.reject(error);
                });

                return completed.promise;
            }

            angular.forEach(users, function(person) {
                promises.push(deleteSinglePermission(person));
            });

            $q.all(promises).then(function() {
                updateList();
                done.resolve();
            }, function(errorText) {
                updateList();
                MessageManager.addErrorMessage(MessageProvider.permissionDeleteFail);
                done.reject();
            });

            return done.promise;
        }

        //update the sharelink permission
        function updateShareLinkPermission() {
            var completed = $q.defer();
            if ($scope.shareLinkOption === SHARE_LINK_OPTION.PRIVATE) {
                if (principalId) {
                    ResourceService.deleteResourcePermission(shareResourceId, principalId).then(function resolveSuccess(res) {
                        completed.resolve();
                    }, function resolveError(reason) {
                        completed.reject(reason);
                        MessageManager.addErrorMessage(MessageProvider.linkUpdateFail);
                    });
                }
            } else {
                var role = ($scope.shareLinkOption === SHARE_LINK_OPTION.READ) ? globalRoles.VIEWER : globalRoles.CONTRIBUTOR;

                ResourceService.updateOrgPermissions(shareResourceId, currentOwnerInfo.OrganizationId, role).then(function resolveSuccess(orgPrincipalInfo) {
                    if (orgPrincipalInfo) {
                        principalId = orgPrincipalInfo.Id;
                        principalRole = orgPrincipalInfo.Role;
                    }
                    completed.resolve();
                }, function resolveError(reason) {
                    completed.reject(reason);
                    MessageManager.addErrorMessage(MessageProvider.linkUpdateFail);
                });
            }
            return completed.promise;
        }

        function updateShareLinkInput() {
            if (!$scope.shareLinkOption) {
                $scope.shareLink = '...';
            } else if ($scope.shareLinkOption === SHARE_LINK_OPTION.PRIVATE) {
                $scope.shareLink = $translate.instant('MODAL.GENERATE_LINK_MODAL.PRIVATE');
            } else {
                var link = $document[0].createElement('a');
                link.href = (isFolder ? '#/folder/' : '#/document/') + encodeURIComponent(shareResourceId);
                $scope.shareLink = link;
            }
        }

        function storePreviousDirectSharedPrincipals(principals) {
            var previousDirectSharedPrincipals = angular.copy(principals);
            angular.forEach(previousDirectSharedPrincipals, function(principal) {
                previousDirectSharedPrincipalsMap[principal.Id] = principal.Role;
            });
        }

        function getSharedPrincipals() {
            var resourcePermissions = null;

            ResourceService.describeResourcePermissions(shareResourceId, ['PRINCIPALS']).then(function success(response) {
                response = response.data ? response.data : response;
                resourcePermissions = ResourceService.processResourcePermissionResponse(response, currentOwnerInfo, false);
                $scope.sharedPrincipals = resourcePermissions.principals;
                storePreviousDirectSharedPrincipals(resourcePermissions.principals.direct);
            }, function error(err) {
                $log.error(err);
            });
        }

        function getOrganizationPrincipals() {
            ResourceService.getOrganizationPrincipal(shareResourceId).then(function success(orgPrincipalInfo) {
                if (orgPrincipalInfo) {
                    principalId = orgPrincipalInfo.Id;
                    principalRole = orgPrincipalInfo.Role;
                }

                switch (principalRole) {
                    case globalRoles.CONTRIBUTOR:
                        $scope.shareLinkOption = SHARE_LINK_OPTION.READ_WRITE;
                        break;
                    case globalRoles.VIEWER:
                        $scope.shareLinkOption = SHARE_LINK_OPTION.READ;
                        break;
                    default:
                        $scope.shareLinkOption = SHARE_LINK_OPTION.PRIVATE;
                }

                previousLinkOption = angular.copy($scope.shareLinkOption);

                updateShareLinkInput();
            }, function error(err) {
                $log.error(err);
            });
        }
        // Convert a typeahead wrapper to a collaborator object required for ResourceService.
        function resourceServiceCollaborator(collaboratorWrapper) {
            var result = {
                type: collaboratorWrapper.type,
                role: collaboratorWrapper.roleType
            };

            switch (result.type) {
                case collaboratorTypes.USER:
                    result.id = collaboratorWrapper.metadata.Id;
                    result.email = collaboratorWrapper.metadata.Username;
                    break;
                case collaboratorTypes.INVITE:
                    // For an anonymous user, use an username (email) as an Id.
                    result.id = collaboratorWrapper.metadata.Username;
                    result.email = result.id;
                    break;
                case collaboratorTypes.GROUP:
                    result.id = collaboratorWrapper.metadata.Id;
                    result.vendor = collaboratorWrapper.metadata.Vendor;
                    break;
            }

            return result;
        }

        function resourceServiceExistedCollaborator(collaboratorWrapper) {
            var result = {
                type: collaboratorWrapper.Type,
                role: collaboratorWrapper.Role
            };

            switch (result.type) {
                case collaboratorTypes.USER:
                    result.id = collaboratorWrapper.Id;
                    result.email = collaboratorWrapper.Username;
                    break;
                case collaboratorTypes.INVITE:
                    result.id = collaboratorWrapper.Username;
                    result.email = result.id;
                    break;
                case collaboratorTypes.GROUP:
                    result.id = collaboratorWrapper.Id;
                    result.vendor = collaboratorWrapper.Vendor;
                    break;
            }
            return result;
        }

        function createPermission(data) {
            if (pendingShareType === TYPE_FOLDER) {
                return createFolderPermission(data);
            } else {
                return createDocumentPermission(data);
            }
        }

        function createFolderPermission(data) {
            var done = $q.defer();

            if (!data) {
                done.reject();
                return done.promise;
            }

            ResourceService.addResourcePermissions(data.shareResourceId, data.role, data.collaborators, data.message).then(function(response) {
                response = response.data ? response.data : response;
                if (response && response.ShareResults) {
                    var allSharesSucceeded = true;
                    var shareStatus, shareStatusMessage;
                    angular.forEach(response.ShareResults, function(value) {
                        if (allSharesSucceeded && value.Status === SHARE_RESULT.SHARE_FAILURE) {
                            allSharesSucceeded = false;
                            shareStatus = value.Status;
                            shareStatusMessage = value.StatusMessage;
                        }
                    });

                    // Send status and statueMessage to errorObj
                    if (!allSharesSucceeded) {
                        done.reject({
                            Status: shareStatus,
                            StatusMessage: shareStatusMessage
                        });
                        return done.promise;
                    } else {
                        // If all the shares are successful
                        done.resolve();
                    }
                }
            }, function(error) {
                done.reject(error);
            });

            return done.promise;
        }

        function onDocumentShareSuccess(feedbackRequested, response, done) {
            var allSharesSucceeded = true;
            var shareStatus, shareStatusMessage;
            angular.forEach(response, function(value, key) {
                // Key is the user email address, value has two types of results: "GRANTED" or "FAILED" (strings in permissions V1), or an object (permissions V2).
                if (allSharesSucceeded && (value === SHARE_RESULT.FEEDBACK_FAILURE || value.Status === SHARE_RESULT.SHARE_FAILURE)) {
                    allSharesSucceeded = false;
                    shareStatus = value.Status;
                    shareStatusMessage = value.StatusMessage;
                }
            });

            // Send status and statueMessage to errorObj
            if (!allSharesSucceeded) {
                done.reject({
                    Status: shareStatus,
                    StatusMessage: shareStatusMessage
                });
            } else {
                done.resolve();
            }
            return done;
        }

        function createDocumentPermission(data) {
            if (!data) {
                done.reject();
                return;
            }

            var done = $q.defer(),
                feedbackRequested = data.feedbackRequested;

            if (feedbackRequested) {
                if (data.feedbackRequestList.length >= 1) {
                    DocumentService.sendFeedbackRequest(data.shareResourceId, data.feedbackRequestList, data.message, data.deadline).then(function success(response) {
                        response = response.data ? response.data : response;
                        done = onDocumentShareSuccess(feedbackRequested, response.FeedbackRequestResponse, done);
                    }, function error(response) {
                        done.reject(response);
                    });
                }
            }

            if (data.collaborators.length > 0) {
                ResourceService.addResourcePermissions(data.shareResourceId, data.role, data.collaborators, data.message).then(function success(response) {
                    response = response.data ? response.data : response;
                    done = onDocumentShareSuccess(feedbackRequested, response.ShareResults, done);
                }, function error(response) {
                    done.reject(response);
                });
            }

            return done.promise;
        }
    }

}());
